import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  questionData: [],
  questionDetails: {},
  isOpenModal: false,
  isStatusOpenModal: false,
  addPreview: false,
  addPreviewId: "",
  examLanguage: 'english',
}

export const QuestionSlice = createSlice({
  name: "Question",
  initialState,
  reducers: {
    setQuestionData(state, { payload }) {
      state.questionData = payload
    },
    setQuestionDetails(state, { payload }) {
      state.questionDetails = payload
    },
    updateQuestionData(state, { payload }) {
      const objIndex = state.questionData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.questionData[objIndex] = payload
      }
    },
    deleteQuestionData(state, { payload }) {
      const objIndex = state.questionData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.questionData.splice(objIndex, 1)
      }
    },
    pushQuestionData(state, { payload }) {
      state.questionData.push(payload)
    },
    setAddPreview(state, { payload }) {
      state.addPreview = true;
      state.addPreviewId = payload.result._id
    },
    removeAddPreview(state) {
      state.addPreview = false
    },
    examLanguage(state, { payload }) {
      state.examLanguage = payload
    }
  }
})

export const { setAddPreview, setQuestionData, setQuestionDetails, removeAddPreview, updateQuestionData, deleteQuestionData, pushQuestionData, examLanguage } = QuestionSlice.actions;

export default QuestionSlice.reducer;

export function getQuestion(id) {
  return async function getQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getQuestion(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setQuestionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function getQuestionById(id) {
  return async function getQuestionByIdThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getQuestionById(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setQuestionDetails(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addQuestion(payload) {
  return async function addQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addQuestion(payload).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(pushQuestionData(response.data))
          dispatch(setAddPreview(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateQuestion(payload) {
  return async function updateQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateQuestion(payload.questionId, payload.data).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setAddPreview(response.data))
          dispatch(updateQuestionData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleteQuestion(payload) {
  return async function statuseleteQuestionThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.DeleteQuestion(payload).then(
        (response) => {
          dispatch(deleteQuestionData(payload))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

